<template>
  <DialogWrapper :title="title" overlayColor="#3776CB" @click-outside="cancel" @close-dialog="cancel" :dialog="popUpValue" :maxWidth="500">
    <template #header v-if="!title">
        <slot name="title"></slot>
        <v-btn icon dark @click="cancel" class="close-btn">
          <FontIcon :color="'grey'" class="close-icn">mdi-close</FontIcon>
        </v-btn>
    </template>
    <div class="hint">
      <slot name="message"></slot>
    </div>
    <template v-slot:actions>
      <v-row no-gutters justify="center">
        <slot class="hint" name="button">
          <div>
            <ActionButton data-test="confirm"
                          label="delete_action"
                          @click="confirm"/>
          </div>
        </slot>
      </v-row>
    </template>
  </DialogWrapper>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import FontIcon from '@/components/FontIcon.vue';
import DialogWrapper from '@/components/DialogWrapper.vue';
import ActionButton from '@/components/ActionButton.vue';

@Component({
  components: {
    ActionButton,
    FontIcon,
    DialogWrapper
  }
})
export default class ConfirmationDialog extends Vue {
  @Prop({ required: false })
  public popUpValue: any;

  @Prop({ required: false })
  public title: string | undefined;

  // METHODS =======================================================
  private confirm() {
    this.$emit('confirm');
  }

  private cancel() {
    this.$emit('cancel');
  }

  // HOOKS =======================================================
}
</script>

<style lang="stylus">
#app {
  .confirm-dialog-header {
    text-align: center;
    padding: 15px;
    margin-bottom: 0px;
    color: #FFFFFF;
  }
}
</style>
